import {api} from '../../helpers/Api'
import {DataBuyer, PaymentCard} from './DataBuyer'

export default class BuyerRequest {
  static getBuyerUser(publictoken: string, buyerToken: string): any {
    return api(publictoken).get(`/buyerUsers?u=${buyerToken}`)
  }

  static getPaymentCards = (publictoken, id, authToken): Promise<IPromisePaymentCard> => {
    return api(publictoken).get<any, IPromisePaymentCard>(`/buyers/${id}/paymentCards?u=${authToken}`)
  }
  
  static sendCart = (publictoken, cartToken, dataBuyer: DataBuyer) => {
    return api(publictoken).post(`/agencies/cart?public=${publictoken}&cartToken=${cartToken}&buyerUser_id=${dataBuyer.buyerUser.id}`)
  }
  
  static sendPayment = (publictoken, {data}) => {
    
  }
} 

interface IPromisePaymentCard {
  result: string
  payload: PaymentCard[]
}